import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.View.extend({
  initialize: function () {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.$loading = $('#loading-view', this.$el);
    if (this.$loading.length === 0) {
      this.$loading = $(require('html-loader!core/js/loading.html'))
        .filter('#loading-view');
    }
    this.$centerLoadingImg = $('.center-loading-img', this.$loading);
  },

  hide: function () {
    this.$loading.fadeOut(400, _.bind(function () {
      this.$loading.remove();
      this.trigger('hidden');
    }, this));
  },

  show: function () {
    if (!$.contains(document, this.$loading[0])) {
      this.$el.append(this.$loading);
    }
    this.$loading.fadeIn();
    this.$loading.css({ height: $(document).height() });
    var newY = $(window).scrollTop() + $(window).height() / 2;
    this.$centerLoadingImg.css({ top: newY - 75 });
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/orcas-core/core/static/js/core/views/loading.js
// module id = 11
// module chunks = 0